import { render, staticRenderFns } from "./alert-banner.vue?vue&type=template&id=1c897053&scoped=true&"
import script from "./alert-banner.vue?vue&type=script&lang=js&"
export * from "./alert-banner.vue?vue&type=script&lang=js&"
import style0 from "./alert-banner.vue?vue&type=style&index=0&id=1c897053&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c897053",
  null
  
)

export default component.exports